/* src/app/components/message/message.component.scss */
.message,
.message--success,
.message--warning,
.message--error,
.message--standard {
  padding: 6px;
  font-weight: 700;
  text-align: center;
  color: var(--ion-color-primary);
  margin: 6px auto;
  max-width: 800px;
}
.message ion-icon,
.message--success ion-icon,
.message--warning ion-icon,
.message--error ion-icon,
.message--standard ion-icon {
  font-size: 22px;
  margin-bottom: -5px;
}
.message--primary {
  border-color: var(--ion-color-primary);
  color: var(--ion-color-primary);
}
.message--error {
  border-color: var(--ion-color-danger);
  color: var(--ion-color-danger);
}
.message--warning {
  border-color: var(--ion-color-warning);
  color: var(--ion-color-warning);
}
.message--success {
  border-color: var(--ion-color-success);
  color: var(--ion-color-success);
}
.message--standard {
  border-color: var(--ion-color-dark);
  color: var(--ion-color-dark);
}
/*# sourceMappingURL=message.component-2A6I4XWH.css.map */
